module.exports = __webpack_public_path__ + "media/assets/images/smart_working/personas-2-bg-090e77921f9fdcaf0cf4bb975e440c2f.jpg";